export default __webpack_public_path__ + "static/media/elevate-dmb-poster-3.621510d0.jpg";